<template>
<div class="st-auth-root">
  <!-- STEP 1: Registration Form -->
  <div class="st-auth-card" style="max-width:480px;" v-if="step === 'register'">
    <div class="text-center mb-4">
      <img src="assets/images/simi_trac_logo.png" alt="Simi Trac" style="height:50px;" />
      <h4 class="mt-3" style="color:#E8EDF4;font-weight:700;">Register Your School</h4>
      <p style="color:#8BA4C4;font-size:14px;">Get started free with 500 SMS credits</p>
    </div>
    <div class="st-alert st-alert-danger" v-if="error">{{ error }}</div>
    <div class="mb-3"><label class="st-label">Institution Name *</label><input class="st-input" v-model="form.name" placeholder="e.g. Greenfield Academy" /></div>
    <div class="mb-3"><label class="st-label">Institution Type</label>
      <select class="st-select" v-model="form.type"><option value="primary_school">Primary School</option><option value="high_school">High School</option><option value="university">University</option><option value="college">College</option><option value="mixed">Mixed</option></select>
    </div>
    <div class="row g-3 mb-3">
      <div class="col-6"><label class="st-label">Admin Name *</label><input class="st-input" v-model="form.adminName" placeholder="Your full name" /></div>
      <div class="col-6"><label class="st-label">City</label><input class="st-input" v-model="form.city" placeholder="Nairobi" /></div>
    </div>
    <div class="mb-3"><label class="st-label">Email *</label><input type="email" class="st-input" v-model="form.email" placeholder="admin@school.ac.ke" /></div>
    <div class="mb-3"><label class="st-label">Phone Number *</label><input class="st-input" v-model="form.phone" placeholder="0712345678" /></div>
    <div class="mb-3"><label class="st-label">Password *</label><input type="password" class="st-input" v-model="form.password" placeholder="Min 6 characters" /></div>
    <div class="mb-3"><label class="st-label">Confirm Password *</label><input type="password" class="st-input" v-model="form.confirmPassword" placeholder="Repeat password" /></div>
    <button class="btn st-btn-primary w-100" @click="register" :disabled="loading">
      <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
      {{ loading ? 'Registering...' : 'Register & Verify' }}
    </button>
    <p class="text-center mt-3" style="color:#8BA4C4;font-size:14px;">Already have an account? <a href="javascript:void(0)" @click="$router.push('/login')" class="st-link">Sign In</a></p>
  </div>

  <!-- STEP 2: Phone OTP Verification -->
  <div class="st-auth-card" v-if="step === 'phone_otp'">
    <div class="text-center mb-4">
      <img src="assets/images/simi_trac_logo.png" alt="Simi Trac" style="height:50px;" />
      <div class="st-otp-icon mt-3"><i class="mdi mdi-cellphone-check"></i></div>
      <h4 class="mt-3" style="color:#E8EDF4;font-weight:700;">Verify Phone Number</h4>
      <p style="color:#8BA4C4;font-size:14px;">Enter the 6-digit code sent via SMS to</p>
      <p style="color:#4FC3F7;font-weight:600;">{{ maskedPhone }}</p>
    </div>
    <div class="st-steps-bar mb-4">
      <div class="st-step-dot active"></div>
      <div class="st-step-line"></div>
      <div class="st-step-dot"></div>
    </div>
    <div class="st-alert st-alert-danger" v-if="otpError">{{ otpError }}</div>
    <div class="st-alert st-alert-success" v-if="otpSuccess">{{ otpSuccess }}</div>
    <div class="st-otp-inputs mb-4">
      <input v-for="(d, i) in 6" :key="'p'+i" type="text" maxlength="1" class="st-otp-digit"
        :ref="'phoneOtp'+i" v-model="phoneOtpDigits[i]"
        @input="onOtpInput('phone', i)" @keydown.backspace="onOtpBackspace('phone', i, $event)" @paste="onOtpPaste('phone', $event)" />
    </div>
    <button class="btn st-btn-primary w-100" @click="verifyPhone" :disabled="otpLoading || phoneOtpCode.length < 6">
      <span v-if="otpLoading" class="spinner-border spinner-border-sm me-1"></span>
      {{ otpLoading ? 'Verifying...' : 'Verify Phone' }}
    </button>
    <div class="text-center mt-3">
      <p style="color:#8BA4C4;font-size:13px;" v-if="phoneResendTimer > 0">Resend in <strong style="color:#4FC3F7;">{{ phoneResendTimer }}s</strong></p>
      <a href="javascript:void(0)" v-else @click="resendOTP('phone')" class="st-link">Resend SMS Code</a>
    </div>
  </div>

  <!-- STEP 3: Email OTP Verification -->
  <div class="st-auth-card" v-if="step === 'email_otp'">
    <div class="text-center mb-4">
      <img src="assets/images/simi_trac_logo.png" alt="Simi Trac" style="height:50px;" />
      <div class="st-otp-icon mt-3" style="background:rgba(16,185,129,.12);"><i class="mdi mdi-email-check" style="color:#10B981;"></i></div>
      <h4 class="mt-3" style="color:#E8EDF4;font-weight:700;">Verify Email Address</h4>
      <p style="color:#8BA4C4;font-size:14px;">Enter the 6-digit code sent to</p>
      <p style="color:#10B981;font-weight:600;">{{ maskedEmail }}</p>
    </div>
    <div class="st-steps-bar mb-4">
      <div class="st-step-dot done"><i class="mdi mdi-check" style="font-size:12px;"></i></div>
      <div class="st-step-line done"></div>
      <div class="st-step-dot active"></div>
    </div>
    <div class="st-alert st-alert-danger" v-if="otpError">{{ otpError }}</div>
    <div class="st-alert st-alert-success" v-if="otpSuccess">{{ otpSuccess }}</div>
    <div class="st-otp-inputs mb-4">
      <input v-for="(d, i) in 6" :key="'e'+i" type="text" maxlength="1" class="st-otp-digit"
        :ref="'emailOtp'+i" v-model="emailOtpDigits[i]"
        @input="onOtpInput('email', i)" @keydown.backspace="onOtpBackspace('email', i, $event)" @paste="onOtpPaste('email', $event)" />
    </div>
    <button class="btn st-btn-primary w-100" style="background:linear-gradient(135deg,#10B981,#059669);" @click="verifyEmail" :disabled="otpLoading || emailOtpCode.length < 6">
      <span v-if="otpLoading" class="spinner-border spinner-border-sm me-1"></span>
      {{ otpLoading ? 'Verifying...' : 'Verify Email & Complete' }}
    </button>
    <div class="text-center mt-3">
      <p style="color:#8BA4C4;font-size:13px;" v-if="emailResendTimer > 0">Resend in <strong style="color:#10B981;">{{ emailResendTimer }}s</strong></p>
      <a href="javascript:void(0)" v-else @click="resendOTP('email')" class="st-link">Resend Email Code</a>
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import { executeJson, simitrack } from "@/api";
export default {
  name: "Register",
  data() {
    return {
      step: 'register',
      form: { name: '', type: 'mixed', adminName: '', email: '', phone: '', password: '', confirmPassword: '', city: '' },
      loading: false,
      error: '',
      // Phone OTP
      phoneOtpDigits: ['', '', '', '', '', ''],
      // Email OTP
      emailOtpDigits: ['', '', '', '', '', ''],
      otpLoading: false,
      otpError: '',
      otpSuccess: '',
      phoneResendTimer: 60,
      emailResendTimer: 60,
      phoneInterval: null,
      emailInterval: null,
      regData: null,
    };
  },
  computed: {
    phoneOtpCode() { return this.phoneOtpDigits.join(''); },
    emailOtpCode() { return this.emailOtpDigits.join(''); },
    maskedPhone() {
      var p = this.form.phone || '';
      if (p.length >= 8) return p.slice(0, 4) + '****' + p.slice(-2);
      return p;
    },
    maskedEmail() {
      var e = this.form.email || '';
      var parts = e.split('@');
      if (parts.length === 2 && parts[0].length > 2) return parts[0].slice(0, 2) + '***@' + parts[1];
      return e;
    }
  },
  beforeUnmount() {
    if (this.phoneInterval) clearInterval(this.phoneInterval);
    if (this.emailInterval) clearInterval(this.emailInterval);
  },
  methods: {
    async register() {
      this.error = '';
      if (!this.form.name || !this.form.email || !this.form.password || !this.form.adminName || !this.form.phone) {
        this.error = 'Please fill in all required fields'; return;
      }
      if (this.form.password !== this.form.confirmPassword) { this.error = 'Passwords do not match'; return; }
      if (this.form.password.length < 6) { this.error = 'Password must be at least 6 characters'; return; }
      this.loading = true;
      try {
        var r = await executeJson({ function: 'registerInstitution', ...this.form }, simitrack);
        if (r.data.success) {
          this.regData = r.data.data;
          this.step = 'phone_otp';
          this.startTimer('phone');
          this.$nextTick(() => { var el = this.$refs['phoneOtp0']; if (el && el[0]) el[0].focus(); });
        } else { this.error = r.data.message || 'Registration failed'; }
      } catch (e) { this.error = 'Connection error. Please try again.'; }
      this.loading = false;
    },

    async verifyPhone() {
      if (this.phoneOtpCode.length < 6) { this.otpError = 'Enter the full 6-digit code'; return; }
      this.otpLoading = true; this.otpError = ''; this.otpSuccess = '';
      try {
        var r = await executeJson({
          function: 'verifyOTP', identifier: this.form.phone, code: this.phoneOtpCode,
          userId: this.regData.userId, channel: 'phone'
        }, simitrack);
        if (r.data.success) {
          if (r.data.data.allVerified) {
            this.loginAfterVerification(r.data.data);
          } else {
            this.otpSuccess = 'Phone verified! Now verify your email.';
            setTimeout(() => {
              this.step = 'email_otp';
              this.otpError = ''; this.otpSuccess = '';
              this.startTimer('email');
              this.$nextTick(() => { var el = this.$refs['emailOtp0']; if (el && el[0]) el[0].focus(); });
            }, 1000);
          }
        } else {
          this.otpError = r.data.message || 'Invalid OTP';
          this.phoneOtpDigits = ['', '', '', '', '', ''];
          this.$nextTick(() => { var el = this.$refs['phoneOtp0']; if (el && el[0]) el[0].focus(); });
        }
      } catch (e) { this.otpError = 'Connection error'; }
      this.otpLoading = false;
    },

    async verifyEmail() {
      if (this.emailOtpCode.length < 6) { this.otpError = 'Enter the full 6-digit code'; return; }
      this.otpLoading = true; this.otpError = ''; this.otpSuccess = '';
      try {
        var r = await executeJson({
          function: 'verifyOTP', identifier: this.form.email, code: this.emailOtpCode,
          userId: this.regData.userId, channel: 'email'
        }, simitrack);
        if (r.data.success) {
          if (r.data.data.allVerified) {
            this.otpSuccess = 'Email verified! Redirecting to dashboard...';
            setTimeout(() => { this.loginAfterVerification(r.data.data); }, 1000);
          } else {
            this.otpSuccess = r.data.message;
          }
        } else {
          this.otpError = r.data.message || 'Invalid OTP';
          this.emailOtpDigits = ['', '', '', '', '', ''];
          this.$nextTick(() => { var el = this.$refs['emailOtp0']; if (el && el[0]) el[0].focus(); });
        }
      } catch (e) { this.otpError = 'Connection error'; }
      this.otpLoading = false;
    },

    loginAfterVerification(data) {
      localStorage.setItem('authToken', data.token);
      sessionStorage.setItem('isLoggedIn', 'true');
      sessionStorage.setItem('userId', data.user.id);
      sessionStorage.setItem('userName', data.user.name);
      sessionStorage.setItem('userRole', data.user.role);
      if (data.institution) {
        sessionStorage.setItem('institutionId', data.institution.id);
        sessionStorage.setItem('institutionName', data.institution.name);
      }
      this.$router.push('/dashboard');
    },

    async resendOTP(channel) {
      this.otpError = ''; this.otpSuccess = '';
      var identifier = channel === 'phone' ? this.form.phone : this.form.email;
      try {
        var r = await executeJson({
          function: 'resendOTP', identifier: identifier,
          userId: this.regData ? this.regData.userId : '', channel: channel
        }, simitrack);
        if (r.data.success) {
          this.otpSuccess = 'New code sent!';
          if (channel === 'phone') { this.phoneOtpDigits = ['', '', '', '', '', '']; this.startTimer('phone'); }
          else { this.emailOtpDigits = ['', '', '', '', '', '']; this.startTimer('email'); }
        } else { this.otpError = r.data.message || 'Failed to resend'; }
      } catch (e) { this.otpError = 'Connection error'; }
    },

    startTimer(channel) {
      if (channel === 'phone') {
        this.phoneResendTimer = 60;
        if (this.phoneInterval) clearInterval(this.phoneInterval);
        this.phoneInterval = setInterval(() => { this.phoneResendTimer--; if (this.phoneResendTimer <= 0) clearInterval(this.phoneInterval); }, 1000);
      } else {
        this.emailResendTimer = 60;
        if (this.emailInterval) clearInterval(this.emailInterval);
        this.emailInterval = setInterval(() => { this.emailResendTimer--; if (this.emailResendTimer <= 0) clearInterval(this.emailInterval); }, 1000);
      }
    },

    // OTP input handling
    onOtpInput(type, idx) {
      var digits = type === 'phone' ? this.phoneOtpDigits : this.emailOtpDigits;
      var prefix = type === 'phone' ? 'phoneOtp' : 'emailOtp';
      var val = digits[idx];
      if (val && val.length > 0) {
        digits[idx] = val.slice(-1);
        if (idx < 5) { var next = this.$refs[prefix + (idx + 1)]; if (next && next[0]) next[0].focus(); }
      }
    },
    onOtpBackspace(type, idx, e) {
      var digits = type === 'phone' ? this.phoneOtpDigits : this.emailOtpDigits;
      var prefix = type === 'phone' ? 'phoneOtp' : 'emailOtp';
      if (!digits[idx] && idx > 0) { var prev = this.$refs[prefix + (idx - 1)]; if (prev && prev[0]) { prev[0].focus(); digits[idx - 1] = ''; } }
    },
    onOtpPaste(type, e) {
      var digits = type === 'phone' ? this.phoneOtpDigits : this.emailOtpDigits;
      var prefix = type === 'phone' ? 'phoneOtp' : 'emailOtp';
      var paste = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '').slice(0, 6);
      for (var i = 0; i < paste.length && i < 6; i++) digits[i] = paste[i];
      e.preventDefault();
      var el = this.$refs[prefix + Math.min(paste.length, 5)]; if (el && el[0]) el[0].focus();
    }
  }
};
</script>

<style scoped>
.st-auth-root{min-height:100vh;display:flex;align-items:center;justify-content:center;background:#0A1628;padding:20px;}
.st-auth-card{background:#0F2347;border:1px solid #1A3A6A;border-radius:20px;padding:40px;width:100%;max-width:440px;box-shadow:0 20px 60px rgba(0,0,0,.3);}
.st-label{color:#8BA4C4;font-size:13px;font-weight:600;margin-bottom:6px;display:block;}
.st-input{width:100%;background:#0A1628;border:1px solid #1A3A6A;border-radius:10px;padding:10px 14px;color:#E8EDF4;font-size:14px;outline:none;transition:border .2s;}
.st-input:focus{border-color:#2E86DE;}.st-input::placeholder{color:#4A6B8A;}
.st-select{width:100%;background:#0A1628;border:1px solid #1A3A6A;border-radius:10px;padding:10px 14px;color:#E8EDF4;font-size:14px;outline:none;}
.st-btn-primary{background:linear-gradient(135deg,#2E86DE,#1A6BC4);color:#fff;border:none;font-weight:600;border-radius:10px;padding:12px;font-size:15px;transition:all .2s;}
.st-btn-primary:hover{box-shadow:0 4px 20px rgba(46,134,222,.4);}.st-btn-primary:disabled{opacity:.6;}
.st-link{color:#4FC3F7;text-decoration:none;font-size:13px;font-weight:500;}.st-link:hover{text-decoration:underline;}
.st-alert{padding:10px 14px;border-radius:10px;font-size:13px;margin-bottom:16px;}
.st-alert-danger{background:rgba(255,107,107,.1);border:1px solid rgba(255,107,107,.2);color:#FF9999;}
.st-alert-success{background:rgba(16,185,129,.1);border:1px solid rgba(16,185,129,.2);color:#6EE7B7;}
.st-otp-icon{width:64px;height:64px;background:rgba(46,134,222,.12);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto;}
.st-otp-icon i{font-size:30px;color:#2E86DE;}
.st-otp-inputs{display:flex;justify-content:center;gap:10px;}
.st-otp-digit{width:48px;height:56px;background:#0A1628;border:2px solid #1A3A6A;border-radius:12px;text-align:center;color:#E8EDF4;font-size:24px;font-weight:700;outline:none;transition:border .2s;}
.st-otp-digit:focus{border-color:#2E86DE;box-shadow:0 0 0 3px rgba(46,134,222,.2);}
.st-steps-bar{display:flex;align-items:center;justify-content:center;gap:0;}
.st-step-dot{width:28px;height:28px;border-radius:50%;border:2px solid #1A3A6A;display:flex;align-items:center;justify-content:center;color:#1A3A6A;font-size:14px;font-weight:700;transition:all .3s;}
.st-step-dot.active{border-color:#2E86DE;background:rgba(46,134,222,.15);color:#4FC3F7;}
.st-step-dot.done{border-color:#10B981;background:#10B981;color:#fff;}
.st-step-line{width:60px;height:2px;background:#1A3A6A;}
.st-step-line.done{background:#10B981;}
</style>
